import { render, staticRenderFns } from "./BasicInfo.vue?vue&type=template&id=cdca75e4&scoped=true&"
import script from "./BasicInfo.vue?vue&type=script&lang=js&"
export * from "./BasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BasicInfo.vue?vue&type=style&index=0&id=cdca75e4&lang=scss&scoped=true&"
import style1 from "./BasicInfo.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdca75e4",
  null
  
)

export default component.exports